var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogBgStripes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1919,
    height: 1320,
    viewBox: "0 0 1919 1320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 890.568,
    transform: "matrix(1 0 0 -1 174.453 1319.48)",
    fill: "url(#paint0_linear_107_553)",
    fillOpacity: 0.51
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 890.568,
    transform: "matrix(1 0 0 -1 0 1319.48)",
    fill: "url(#paint1_linear_107_553)",
    fillOpacity: 0.51
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 890.568,
    transform: "matrix(1 0 0 -1 610.594 1319.48)",
    fill: "url(#paint2_linear_107_553)",
    fillOpacity: 0.51
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1008.44,
    transform: "matrix(1 0 0 -1 1046.73 1319.48)",
    fill: "url(#paint3_linear_107_553)",
    fillOpacity: 0.51
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1129.58,
    transform: "matrix(1 0 0 -1 1482.86 1319.48)",
    fill: "url(#paint4_linear_107_553)",
    fillOpacity: 0.51
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 536.96,
    transform: "matrix(1 0 0 -1 261.68 1319.48)",
    fill: "url(#paint5_linear_107_553)",
    fillOpacity: 0.51
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 536.96,
    transform: "matrix(1 0 0 -1 87.2266 1319.48)",
    fill: "url(#paint6_linear_107_553)",
    fillOpacity: 0.51
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 536.96,
    transform: "matrix(1 0 0 -1 697.82 1319.48)",
    fill: "url(#paint7_linear_107_553)",
    fillOpacity: 0.51
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 536.96,
    transform: "matrix(1 0 0 -1 1133.96 1319.48)",
    fill: "url(#paint8_linear_107_553)",
    fillOpacity: 0.51
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 664.652,
    transform: "matrix(1 0 0 -1 1570.09 1319.48)",
    fill: "url(#paint9_linear_107_553)",
    fillOpacity: 0.51
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1165.6,
    transform: "matrix(1 0 0 -1 348.906 1319.48)",
    fill: "url(#paint10_linear_107_553)",
    fillOpacity: 0.51
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 687.571,
    transform: "matrix(1 0 0 -1 785.047 1319.48)",
    fill: "url(#paint11_linear_107_553)",
    fillOpacity: 0.51
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 664.652,
    transform: "matrix(1 0 0 -1 1221.18 1319.48)",
    fill: "url(#paint12_linear_107_553)",
    fillOpacity: 0.51
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1319.48,
    transform: "matrix(1 0 0 -1 1657.32 1319.48)",
    fill: "url(#paint13_linear_107_553)",
    fillOpacity: 0.51
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 687.571,
    transform: "matrix(1 0 0 -1 436.141 1319.48)",
    fill: "url(#paint14_linear_107_553)",
    fillOpacity: 0.51
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1231.08,
    transform: "matrix(1 0 0 -1 872.273 1319.48)",
    fill: "url(#paint15_linear_107_553)",
    fillOpacity: 0.51
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1306.38,
    transform: "matrix(1 0 0 -1 1308.41 1319.48)",
    fill: "url(#paint16_linear_107_553)",
    fillOpacity: 0.51
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 1008.44,
    transform: "matrix(1 0 0 -1 1744.55 1319.48)",
    fill: "url(#paint17_linear_107_553)",
    fillOpacity: 0.51
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 356.882,
    transform: "matrix(1 0 0 -1 523.359 1319.48)",
    fill: "url(#paint18_linear_107_553)",
    fillOpacity: 0.51
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 356.882,
    transform: "matrix(1 0 0 -1 959.5 1319.48)",
    fill: "url(#paint19_linear_107_553)",
    fillOpacity: 0.51
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 848.004,
    transform: "matrix(1 0 0 -1 1395.64 1319.48)",
    fill: "url(#paint20_linear_107_553)",
    fillOpacity: 0.51
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 87.2274,
    height: 356.882,
    transform: "matrix(1 0 0 -1 1831.77 1319.48)",
    fill: "url(#paint21_linear_107_553)",
    fillOpacity: 0.51
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 859.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 859.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 859.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 972.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 1089.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 517.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 517.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 517.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 517.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 641.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 1124.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 663.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 641.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 1272.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 663.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 1187.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 1260.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 972.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 344.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 344.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 817.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_107_553",
    x1: 43.6137,
    y1: 0,
    x2: 43.6137,
    y2: 344.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001A76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AAA0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DAA",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogBgStripes);
export default __webpack_public_path__ + "static/media/blog-bg-stripes.35c6b5a3f72c534eacafb64b0ceeadf9.svg";
export { ForwardRef as ReactComponent };